<template>
  <div class="brain-popover" v-if="showPopover">
    <div class="popover-mask"></div>
    <div class="popover-content">
      <div class="popover-head">
        <span class="popover-title">{{ $t("tags.diagnosis_tags") }} </span>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click.stop="closePopover"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="popover-body">
        <el-form
          :model="diagnosis_tags"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          :status-icon="true"
        >
          <!-- <el-form-item :label="$t('tags.subject_staging')" prop="hy_staging">
            <el-select
              v-model="diagnosis_tags.hy_staging"
              placeholder=""
              style="width: 100%"
            >
              <el-option
                v-for="item in setTagOptionsHystaging"
                :label="item.name"
                :value="item.name"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item :label="$t('tags.subject_staging')" prop="hy_staging">
            <el-radio-group v-model="diagnosis_tags.hy_staging">
              <el-radio
                v-for="item in setTagOptionsHystaging"
                :label="item.name"
                :key="item.id"
                >{{ item.name }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('tags.subject_disease')" prop="course">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                v-model="diagnosis_tags.course"
                :placeholder="'(' + $t('tags.integer_months') + ')'"
              />
            </el-col>
            <el-col :span="11">
              <small class="ml-2 text-muted"
                >({{ $t("tags.integer_months") }})</small
              >
            </el-col>
          </el-form-item>

          <el-form-item :label="$t('tags.education')" prop="education">
            <el-col :span="8">
              <el-input type="text" v-model="diagnosis_tags.education" />
            </el-col>
            <el-col :span="11"> </el-col>
          </el-form-item>

          <el-form-item label="MMSE" prop="mmse">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="30"
                v-model="diagnosis_tags.mmse"
                placeholder="0 ~ 30"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 30)</small>
            </el-col>
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>

          <el-form-item label="MOCA" prop="moca">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="30"
                v-model="diagnosis_tags.moca"
                placeholder="0 ~ 30"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 30)</small>
            </el-col>
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>

          <el-form-item label="HAMA" prop="hama">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="56"
                v-model="diagnosis_tags.hama"
                placeholder="0 ~ 56"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 56)</small>
            </el-col>
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>

          <el-form-item label="HAMD" prop="hamd">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="72"
                v-model="diagnosis_tags.hamd"
                placeholder="0 ~ 72"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 72)</small>
            </el-col>
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>

          <el-form-item label="UPDRS-I" prop="updrs1">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="16"
                v-model="diagnosis_tags.updrs1"
                placeholder="0 ~ 16"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 16)</small>
            </el-col>
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>

          <el-form-item label="UPDRS-II" prop="updrs2">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="52"
                v-model="diagnosis_tags.updrs2"
                placeholder="0 ~ 52"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 52)</small>
            </el-col>
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>

          <el-form-item label="UPDRS-III" prop="updrs3">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="108"
                v-model="diagnosis_tags.updrs3"
                placeholder="0 ~ 108"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 108)</small></el-col
            >
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>

          <el-form-item label="UPDRS-IV" prop="updrs4">
            <el-col :span="8">
              <el-input
                type="number"
                min="0"
                max="19"
                v-model="diagnosis_tags.updrs4"
                placeholder="0 ~ 19"
              />
            </el-col>
            <el-col :span="3">
              <small class="ml-2 text-muted">(0 ~ 19)</small></el-col
            >
            <template #error="{ error }">
              <el-col :span="11">
                <small class="text-danger" v-if="error">
                  {{ error }}
                </small>
              </el-col>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="popover-footer text-right">
        <button
          type="button"
          class="btn btn-grey btn-sm ml10"
          @click.stop="closePopover"
        >
          {{ $t("close") }}
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm ml10"
          @click.stop="submitTags('ruleForm')"
        >
          {{ $t("confirm") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//“病程”
export default {
  props: {
    setTagOptionsHystaging: {
      type: Array,
      default: function () {
        return [];
      },
    },
    diagnosis_tags: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showPopover: {
      type: Boolean,
      default: false,
    },
    subject_id: {
      type: String,
      default: "",
    },
  },
  data() {
    // 自定义区间验证函数
    const validateRange = (rule, value, callback) => {
      if (value < 0 || value > 30) {
        callback(new Error(this.$t("notice.value_range", { min: 0, max: 30 })));
      } else {
        callback();
      }
    };
    const validateRange2 = (rule, value, callback) => {
      if (value < 0 || value > 56) {
        callback(new Error(this.$t("notice.value_range", { min: 0, max: 56 })));
      } else {
        callback();
      }
    };
    const validateRange3 = (rule, value, callback) => {
      if (value < 0 || value > 72) {
        callback(new Error(this.$t("notice.value_range", { min: 0, max: 72 })));
      } else {
        callback();
      }
    };
    const validateRange4 = (rule, value, callback) => {
      if (value < 0 || value > 16) {
        callback(new Error(this.$t("notice.value_range", { min: 0, max: 16 })));
      } else {
        callback();
      }
    };
    const validateRange5 = (rule, value, callback) => {
      if (value < 0 || value > 52) {
        callback(new Error(this.$t("notice.value_range", { min: 0, max: 52 })));
      } else {
        callback();
      }
    };
    const validateRange6 = (rule, value, callback) => {
      if (value < 0 || value > 108) {
        callback(
          new Error(this.$t("notice.value_range", { min: 0, max: 108 }))
        );
      } else {
        callback();
      }
    };
    const validateRange7 = (rule, value, callback) => {
      if (value < 0 || value > 19) {
        callback(new Error(this.$t("notice.value_range", { min: 0, max: 19 })));
      } else {
        callback();
      }
    };
    return {
      rules: {
        mmse: [{ validator: validateRange, trigger: "blur" }],
        moca: [{ validator: validateRange, trigger: "blur" }],
        hama: [{ validator: validateRange2, trigger: "blur" }],
        hamd: [{ validator: validateRange3, trigger: "blur" }],
        updrs1: [{ validator: validateRange4, trigger: "blur" }],
        updrs2: [{ validator: validateRange5, trigger: "blur" }],
        updrs3: [{ validator: validateRange6, trigger: "blur" }],
        updrs4: [{ validator: validateRange7, trigger: "blur" }],
      },
    };
  },
  watch: {
    diagnosis_tags: function (val, oldVal) {
      this.diagnosis_tags = val;
    },
    subject_id: function (val, oldVal) {
      this.subject_id = val;
    },
  },
  computed: {},
  methods: {
    submitTags(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("submitTagsDisease", this.diagnosis_tags, this.subject_id);
        } else {
          console.log("验证失败");
          return false;
        }
      });
    },
    closePopover() {
      this.$emit("closeTagsPopover");
    },
  },
};
</script>

<style scoped>
.popover-body {
  padding: 30px 0px 0px 0;
} /* 自定义错误信息样式和位置 */
</style>